<template>
  <div class="unite-page">
    <div class="home-bg">
      <img class="logo-bg" src="@/assets/home-logo.png" alt="home-logo" />
      <img class="img-bg" src="@/assets/home-bg.png" alt="home-bg" />
      <!-- <div class="top-left">CO-LP</div> -->
    </div>
    <div class="home-main">
      <!-- <div class="home-time">
        <h3 class="time-title">{{ isComing }}</h3>
        <div class="time-outer">
          <div class="time-inner">
            <div class="time" v-for="item in timeList" :key="item.key">
              <span class="value">{{ item.value }}</span>
              <span class="text">{{ item.text }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="home-process">
        <div class="process-top">
          <div class="process-left">
            <span class="process-label">Process</span>
            <span class="process-percent">{{ userInfo.process }}%</span>
          </div>
          <div class="process-right">
            <span class="process-label">({{ saleInfo.pieceSymbol }})Total Amount</span>
            <span class="process-value">{{ userInfo.mQty }} million</span>
          </div>
        </div>
        <div class="process-bar">
          <van-progress :percentage="userInfo.process" :show-pivot="false" stroke-width="20"
            color="linear-gradient(90deg, #74d5ff, #ffffff)" track-color="rgba(116,212,255,0.2)" />
        </div>
      </div> -->

      <!-- <div class="home-info">
        <div class="info-bg">
          <div class="info-input" v-if="isInputOrInfo">
            <van-field v-model="inputAmount" :placeholder="placeholder()" :border="false" class="custom-input" />
            <div class="button-box">
              <van-button :loading="payLoading" loading-text="Pay..." @click="handleClickPayButton">
                JOIN
              </van-button>
            </div>
          </div>
          <div class="info-main" v-else>
            <div class="info-img">
              <img src="@/assets/home-congratulations.png" alt="home-con" />
            </div>
            <div class="info-word">
              {{ infoWord }}
            </div>
            <div class="info-list">
              <div class="list-item" v-for="item in formattedInfoList" :key="item.key">
                <span class="text">{{ item.text }}</span>
                <span class="value">{{ item.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="home-bulletin">
        <div class="bulletin-title">
          <div class="title-top">
            <img src="@/assets/ad-word.png" alt="ad-word" />
          </div>
          <div class="title-bottom">
            <div class="box">
              <img src="@/assets/ad-ad.png" alt="ad-ad" />
              <span>{{ homeNotice }}</span>
            </div>
          </div>
        </div>
        <div class="bulletin-content">
          <div class="bulletin-outer">
            <div class="bulletin-inner">
              <div class="content">
                {{ bulletinContent }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-connect">
        <div class="connect-title">
          <div class="title-bottom">
            <div class="box">
              <img src="@/assets/ad-ad.png" alt="ad-ad" />
              <span>Connect US</span>
            </div>
          </div>
        </div>
        <div class="connect-content">
          <div class="connect-outer">
            <div class="content">
              <a class="content-item" v-for="(a, index) in aList" :key="a.key" :href="a.href">
                <img :src="a.logo" :alt="a.key" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import logo_x from '@/assets/x.svg'
import logo_fly from '@/assets/fly.svg'
// import logo_qq from '@/assets/qq.svg'
import Web3 from 'web3'
import { ERC20_ABI } from '../abi/ERC20_ABI'
import { Mint_ABI } from '../abi/Mint_ABI'
import {
  showFromWei,
  showAccount,
  showLongAccount,
  showLongLongAccount,
  toWei,
  showCountdownTime,
  getRef,
} from '../utils/utils'
import BN from 'bn.js'
import WalletState, { CHAIN_ID, MAX_INT, ZERO_ADDRESS } from '../state/WalletState'
export default {
  name: 'Unite',
  computed: {
    // formattedInfoList() {
    //   const list = this.infoList.map((item) => {
    //     if (item.key === '2') {
    //       const millisecondsTimestamp = Number(item.value)
    //       if (!isNaN(millisecondsTimestamp)) {
    //         item.value = dayjs.unix(millisecondsTimestamp).format('D/M/YYYY')
    //       } else {
    //         console.error('Invalid timestamp:', item.value)
    //       }
    //     }
    //     return item
    //   })
    //   return list
    // },
  },
  mounted() {
    WalletState.onStateChanged(this.handleAccountsChanged)
    this.refreshDataTimer = setInterval(() => {
      this.getInfo()
    }, 15000)
  },
  beforeDestroy() {
    WalletState.removeListener(this.handleAccountsChanged)
    clearInterval(this.refreshDataTimer)
    this.refreshDataTimer = null
  },
  data() {
    return {
      saleInfo: {},
      userInfo: { process: 0 },
      isComing: 'COUNTDOWN',
      timeList: [
        {
          id: '1',
          value: '09',
          text: 'DAY',
        },
        {
          id: '2',
          value: '12',
          text: 'HOUR',
        },
        {
          id: '3',
          value: '43',
          text: 'MINUTE',
        },
        {
          id: '4',
          value: '55',
          text: 'SECOND',
        },
      ],
      infoList: [
        {
          key: '1',
          text: 'Mint',
          value: '1 BNB',
        },
        {
          key: '2',
          text: 'Date',
          value: '1740460800',
        },
        {
          key: '3',
          text: 'Status',
          value: 'success',
        },
      ],
      bulletinContent:
        'Version Dear Investors,The project team hereby solemnly reminds you:Investment in this project and cryptocurrency assets involves extremely high risks. Please fully evaluate and make cautious decisions before participating.Main Risks Include but Are Not Limited to:Risk of Total Loss: You may lose all of your invested capital;Price Volatility Risk: Asset prices may fluctuate dramatically;Regulatory Risk: Changes in policies may have material adverse effects on the project;Technical and Security Risk: Smart contract vulnerabilities or hacker attacks may result in asset losses;Liquidity Risk: Tokens may be difficult to exit at desired prices.Important Legal Disclaimer:This project does not constitute any investment advice, profit commitment, or solicitation.This project prohibits participation by residents, citizens, or entities from countries or regions where cryptocurrency activities are prohibited or strictly restricted. Participants must ensure full compliance with the laws and regulations of their jurisdiction.All investment decisions and any resulting risks and losses are borne solely by the investors.This disclaimer is intended to exclude any warranties, representations, or liabilities to the fullest extent permitted by applicable law.Investment involves risks. Participate with caution.',
      homeNotice: 'NOTICE',
      aList: [
        {
          key: 'x',
          href: 'https://x.com/1piece_meme',
          logo: logo_x,
        },
        {
          key: 'fly',
          href: 'https://t.me/OnePieceGlobalCommunity',
          logo: logo_fly,
        },
        //{
        //  key: 'q q',
        //  href: '#',
        //  logo: logo_qq,
        // },
      ],
      isInputOrInfo: true,
      infoWord: 'You have already completed the minting.',
      payLoading: false,
      inputAmount: '',
    }
  },
  methods: {
    handleClickPayButton() {
      // this.isInputOrInfo = false
      this.mint()
    },
    showAccount,
    toast(msg) {
      this.$toast.fail(msg)
      //this.$notify({ type: "danger", message: msg, duration: 5000 });
    },
    toastSuccess(msg) {
      this.$toast.success(msg)
      //this.$notify({ type: "success", message: msg, duration: 3000 });
    },
    showLoading(msg) {
      this.$toast.loading({
        duration: 0,
        message: msg,
        forbidClick: true,
        loadingType: 'spinner',
      })
    },
    hideLoading() {
      this.$toast.clear()
    },
    async mint() {
      let account = WalletState.wallet.account
      if (!account) {
        this.connetWallet()
        return
      }
      let saleInfo = this.saleInfo
      if (!saleInfo.blockTime) {
        this.toast('wait for info')
        return
      }
      let userInfo = this.userInfo
      if (saleInfo.blockTime < userInfo.start) {
        this.toast('not start')
        return
      }
      if (!userInfo.amount.isZero()) {
        this.toast('joined')
        return
      }
      this.mintLP(account, saleInfo)
    },
    async mintLP(account, saleInfo) {
      let inputAmount = this.inputAmount
      if (!inputAmount) {
        return
      }
      let userInfo = this.userInfo
      let usdtAmount = toWei(inputAmount, saleInfo.usdtDecimals)
      if (usdtAmount.lt(userInfo.mincoLPUsdtAmount) || usdtAmount.gt(userInfo.coLPUsdtAmount)) {
        this.toast('err amount')
        return
      }
      let usdtBalance = userInfo.usdtBalance
      if (usdtBalance.lt(usdtAmount)) {
        this.toast('USDT not enough')
        return
      }
      let usdtAllowance = userInfo.usdtAllowance
      this.payLoading = true
      try {
        const web3 = new Web3(Web3.givenProvider)
        let gasPrice = await web3.eth.getGasPrice()
        gasPrice = new BN(gasPrice, 10)
        let approvalNum = usdtAllowance
        //授权额度不够了，需要重新授权
        if (approvalNum.lt(usdtAmount)) {
          const tokenContract = new web3.eth.Contract(ERC20_ABI, saleInfo.usdtAddress)
          let estimateGas = await tokenContract.methods
            .approve(WalletState.config.Mint, MAX_INT)
            .estimateGas({ from: account })
          let gas = new BN(estimateGas, 10).mul(new BN(120)).div(new BN(100))
          let transaction = await tokenContract.methods.approve(WalletState.config.Mint, MAX_INT).send({
            from: account,
            gas: gas,
            gasPrice: gasPrice,
          })
          if (!transaction.status) {
            toast.show('授权失败')
            return
          }
        }
        userInfo.usdtAllowance = new BN(MAX_INT, 10)
        const poolContract = new web3.eth.Contract(Mint_ABI, WalletState.config.Mint)
        let minPiece = new BN(0)
        minPiece = await poolContract.methods.getUsdtPieceAmount(usdtAmount).call()
        minPiece = new BN(minPiece, 10).mul(new BN(90)).div(new BN(100))

        let estimateGas = await poolContract.methods.coLP(usdtAmount, minPiece).estimateGas({ from: account })
        estimateGas = new BN(estimateGas, 10).mul(new BN(130)).div(new BN(100))
        let transaction = await poolContract.methods
          .coLP(usdtAmount, minPiece)
          .send({ from: account, gas: estimateGas, gasPrice: gasPrice })
        if (transaction.status) {
          this.$toast({ type: 'success', message: 'Mint Success!' })
          this.getInfo()
        } else {
          this.toast('Mint Failed')
        }
      } catch (e) {
        console.log('mint', e)
        this.toast(e.message)
      } finally {
        this.payLoading = false
      }
    },
    placeholder() {
      let userInfo = this.userInfo
      return userInfo.showmincoLPUsdtAmount + '~' + userInfo.showcoLPUsdtAmount + ' USDT'
    },
    async getInfo() {
      if (WalletState.wallet.chainId != CHAIN_ID) {
        return
      }
      try {
        const web3 = new Web3(Web3.givenProvider)
        const poolContract = new web3.eth.Contract(Mint_ABI, WalletState.config.Mint)

        const tokenInfoRet = await poolContract.methods.getTokenInfo().call()
        let tokenAddress = tokenInfoRet[0]
        let tokenDecimals = parseInt(tokenInfoRet[1])
        let tokenSymbol = tokenInfoRet[2]
        let nowTime = parseInt(tokenInfoRet[3])
        let usdtAddress = tokenInfoRet[4]
        let usdtDecimals = parseInt(tokenInfoRet[5])
        let usdtSymbol = tokenInfoRet[6]
        let lpAddress = tokenInfoRet[7]
        //获取基本信息
        const saleInfoRet = await poolContract.methods.getSaleInfo().call()
        let pieceAddress = saleInfoRet[0]
        let pieceDecimals = parseInt(saleInfoRet[1])
        let pieceSymbol = saleInfoRet[2]
        let saleInfo = {
          blockTime: nowTime,
          usdtDecimals: usdtDecimals,
          usdtSymbol: usdtSymbol,
          usdtAddress: usdtAddress,
          pieceSymbol: pieceSymbol,
          lpAddress: lpAddress,
        }
        this.saleInfo = saleInfo

        let account = WalletState.wallet.account
        if (account) {
          //获取用户信息
          const getUserInfoRet = await poolContract.methods.getUserCOLPInfo(account).call()
          let qty = new BN(getUserInfoRet[0], 10)
          let start = parseInt(getUserInfoRet[1])
          let mintAmount = new BN(getUserInfoRet[2], 10)
          let amount = new BN(getUserInfoRet[3], 10)
          let pieceAmount = new BN(getUserInfoRet[4], 10)
          let time = parseInt(getUserInfoRet[5])
          let usdtBalance = new BN(getUserInfoRet[6], 10)
          let usdtAllowance = new BN(getUserInfoRet[7], 10)
          let coLPUsdtAmount = new BN(getUserInfoRet[8], 10)
          let mincoLPUsdtAmount = new BN(getUserInfoRet[9], 10)
          let blockTime = nowTime
          let countTimes
          if (blockTime < start) {
            countTimes = showCountdownTime(start - blockTime)
          } else {
            countTimes = showCountdownTime(0)
          }
          let timeList = this.timeList
          timeList[0].value = countTimes[0]
          timeList[1].value = countTimes[1]
          timeList[2].value = countTimes[2]
          timeList[3].value = countTimes[3]
          this.timeList = timeList
          if (0 == time && !qty.isZero()) {
            this.isInputOrInfo = true
          } else {
            this.isInputOrInfo = false
          }
          let process = mintAmount.mul(new BN(10000)).div(qty).toNumber()
          process = parseInt(process) / 100

          let userInfo = {
            qty: qty,
            mintAmount: mintAmount,
            process: process,
            showQty: showFromWei(qty, pieceDecimals, 2),
            mQty: parseInt(parseInt(showFromWei(qty, pieceDecimals, 0)) / 1000000),
            showMintAmount: showFromWei(mintAmount, pieceDecimals, 2),
            time: time,
            amount: amount,
            showAmount: showFromWei(amount, usdtDecimals, 2),
            pieceAmount: pieceAmount,
            showPieceAmount: showFromWei(pieceAmount, pieceDecimals, 2),
            usdtBalance: usdtBalance,
            usdtAllowance: usdtAllowance,
            coLPUsdtAmount: coLPUsdtAmount,
            showcoLPUsdtAmount: showFromWei(coLPUsdtAmount, usdtDecimals, 2),
            start: start,
            mincoLPUsdtAmount: mincoLPUsdtAmount,
            showmincoLPUsdtAmount: showFromWei(mincoLPUsdtAmount, usdtDecimals, 2),
          }
          this.userInfo = userInfo
          console.log('sale', showFromWei(qty, pieceDecimals, 0), showFromWei(mintAmount, pieceDecimals, 0))

          let infoList = this.infoList
          if (!amount.isZero()) {
            infoList[0].value = showFromWei(amount, usdtDecimals, 2) + ' ' + usdtSymbol
          }
          infoList[1].value = time
          this.infoList = infoList
        }
      } catch (e) {
        console.log('getInfo', e.message)
        this.toast(e.message)
      } finally {
      }
    },
    connetWallet() {
      WalletState.connetWallet()
    },
    handleAccountsChanged() {
      const wallet = WalletState.wallet
      this.chainId = wallet.chainId
      this.account = wallet.account
      this.getInfo()
    },
    showLongAccount,
    showLongLongAccount,
  },
}
</script>

<style lang="less" scoped>
.unite-page {
  min-height: calc(100vh - 44px);
  background-color: #3e8eb1;

  .home-bg {
    position: relative;
    height: 280px;
    margin-bottom: 12px;

    .logo-bg {
      position: absolute;
      top: 5px;
      left: 50%;
      width: 52px;
      height: 52px;
      margin-left: -26px;
    }

    .img-bg {
      width: 100%;
      height: 100%;
    }

    .top-left {
      position: absolute;
      right: 12px;
      color: #999;
      top: 8px;
      font-size: 12px;
      padding: 5px 20px;
      border-radius: 8px;
      background-color: #fff;
    }
  }

  .home-main {
    // padding-bottom: 50px;

    // .home-time {
    //   margin-bottom: 12px;

    //   .time-title {
    //     color: #fff;
    //     font-size: 16px;
    //     font-weight: bold;
    //     text-align: center;
    //     margin-bottom: 12px;
    //   }

    //   .time-outer {
    //     width: 335px;
    //     height: 86px;
    //     border-radius: 8px 8px 8px 8px;
    //     border: 1px solid #74d5ff;
    //     box-sizing: border-box;
    //     padding: 5px;
    //     margin: 0 auto;

    //     .time-inner {
    //       width: 100%;
    //       display: flex;
    //       flex-direction: row;
    //       justify-content: space-between;
    //       align-items: center;

    //       .time {
    //         flex: 1;
    //         height: 74px;
    //         margin-right: 3px;
    //         background: #55a1c2;
    //         border-radius: 3px 3px 3px 3px;
    //         border: 1px solid #74d5ff;
    //         display: flex;
    //         flex-direction: column;
    //         justify-content: center;
    //         align-items: center;
    //         margin-bottom: 12px;

    //         .value {
    //           font-weight: 400;
    //           font-size: 28px;
    //           color: #fffbf1;
    //           line-height: 28px;
    //           text-shadow: 0px 0px 4px rgba(255, 255, 255, 0.5);
    //           margin-bottom: 10px;
    //         }

    //         .text {
    //           font-weight: 400;
    //           font-size: 10px;
    //           color: #fffbf1;
    //           line-height: 10px;
    //         }
    //       }

    //       .time:last-child {
    //         margin-right: 0;
    //       }
    //     }
    //   }
    // }

    // .home-process {
    //   width: 335px;
    //   margin: 0 auto 12px;
    //   padding: 4px;
    //   border-radius: 8px;
    //   border: 1px solid #74d5ff;
    //   box-sizing: border-box;

    //   .process-top {
    //     display: flex;
    //     flex-direction: row;
    //     justify-content: space-between;
    //     margin-bottom: 12px;

    //     .process-left,
    //     .process-right {
    //       flex: 1;
    //       display: flex;
    //       flex-direction: column;
    //       align-items: start;

    //       .process-label {
    //         font-weight: 500;
    //         font-size: 12px;
    //         color: #ccc;
    //         margin-bottom: 4px;
    //       }

    //       .process-percent {
    //         font-weight: bold;
    //         font-size: 18px;
    //         color: #fffbf1;
    //       }

    //       .process-value {
    //         font-weight: bold;
    //         font-size: 18px;
    //         color: #fffbf1;
    //       }
    //     }

    //     .process-right {
    //       align-items: end;
    //     }
    //   }

    //   .process-bar {
    //     border: 1px solid #74d5ff;
    //     padding: 2px;
    //     margin-bottom: 8px;
    //     border-radius: 4px;
    //   }
    // }

    // .home-info {
    //   height: 275px;
    //   margin-bottom: 12px;

    //   .info-bg {
    //     box-sizing: border-box;
    //     height: 100%;
    //     background: url('@/assets/ad-bg.png') no-repeat 0 0;
    //     background-size: 100% 100%;
    //     margin-bottom: 12px;
    //     padding: 60px 29px 54px 11px;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;

    //     .info-input {
    //       width: 100%;
    //       display: flex;
    //       flex-direction: column;
    //       justify-content: center;
    //       row-gap: 12px;
    //       padding: 12px 24px 0;

    //       .custom-input {
    //         background: #fff;
    //         border-radius: 4px;
    //         padding: 6px 12px;
    //         margin-bottom: 8px;
    //       }

    //       .custom-input /deep/ .van-field__body {
    //         background: #fff;
    //       }

    //       .custom-input /deep/ input {
    //         font-size: 14px;
    //         color: #3f2d17;
    //       }

    //       .button-box {
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;

    //         .van-button {
    //           width: 120px;
    //           height: 32px;
    //           line-height: 32px;
    //           background: linear-gradient(0deg, #f0ec80 0%, #eda53a 55.5%, #f0c465 100%);
    //           box-shadow: 0px 6px 12px 0px #76583c, 0px 4px 0px 0px #ecad6f, 0px 2px 2px 0px #d9901e;
    //           border-radius: 19px 19px 19px 19px;
    //           border: 1px solid;
    //           // border-image: linear-gradient(360deg, rgba(240, 231, 123, 1), rgba(239, 208, 101, 1)) 1 1;
    //           color: #fff;
    //           font-size: 14px;
    //           font-weight: 500;
    //         }
    //       }
    //     }

    //     .info-main {
    //       width: 100%;

    //       .info-img {
    //         width: 220px;
    //         height: 48px;
    //         margin: 18px auto 8px;

    //         img {
    //           width: 100%;
    //           height: 100%;
    //         }
    //       }

    //       .info-word {
    //         font-family: Source Han Serif CN, Source Han Serif CN;
    //         font-weight: 500;
    //         font-size: 12px;
    //         color: #6d5f4f;
    //         text-align: center;
    //         margin-bottom: 12px;
    //       }

    //       .info-list {
    //         display: flex;
    //         flex-direction: row;
    //         justify-content: space-between;

    //         .list-item {
    //           flex: 1;
    //           display: flex;
    //           flex-direction: column;
    //           justify-content: center;
    //           align-items: center;

    //           .text {
    //             font-family: Source Han Serif CN, Source Han Serif CN;
    //             font-weight: 500;
    //             font-size: 12px;
    //             color: #6d5f4f;
    //             margin-bottom: 5px;
    //           }

    //           .value {
    //             font-family: Source Han Serif CN, Source Han Serif CN;
    //             font-weight: bold;
    //             font-size: 14px;
    //             color: #3f2d17;
    //           }
    //         }
    //       }
    //     }
    //   }
    // }

    .home-bulletin {
      padding-bottom: 20px;

      .bulletin-title {
        margin-bottom: 16px;

        .title-top {
          width: 101px;
          height: 30px;
          margin: 0 auto;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .title-bottom {
          margin: -18px auto 0;

          .box {
            position: relative;
            width: 200px;
            // height: 15px;
            margin: 0 auto;

            img {
              width: 100%;
              height: 15px;
            }

            span {
              position: absolute;
              top: 50%;
              left: 50%;
              width: 80px;
              height: 16px;
              margin-left: -40px;
              margin-top: -8px;
              text-align: center;
              font-weight: bold;
              font-size: 16px;
              color: #fffbf1;
              font-family: Source Han Serif CN, Source Han Serif CN;
            }
          }
        }
      }

      .bulletin-content {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 12px;

        .bulletin-outer {
          padding: 12px;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #74d5ff;
          display: flex;
          justify-content: center;
          align-items: center;

          .bulletin-inner {
            background: #55a1c2;
            border-radius: 3px 3px 3px 3px;
            border: 1px solid #74d5ff;
            box-sizing: border-box;
            padding: 16px;

            .content {
              font-family: Source Han Serif CN, Source Han Serif CN;
              font-weight: 600;
              font-size: 10px;
              color: #fffbf1;
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }
      }
    }

    .home-connect {
      padding-bottom: 50px;

      .connect-title {
        margin-bottom: 16px;

        .title-bottom {
          margin: -18px auto 0;

          .box {
            position: relative;
            width: 240px;
            margin: 0 auto;

            img {
              width: 100%;
              height: 15px;
            }

            span {
              position: absolute;
              top: 50%;
              left: 50%;
              width: 180px;
              height: 16px;
              margin-left: -90px;
              margin-top: -8px;
              text-align: center;
              font-weight: bold;
              font-size: 16px;
              color: #fffbf1;
              font-family: Source Han Serif CN, Source Han Serif CN;
            }
          }
        }
      }

      .connect-content {
        padding: 0 12px;

        .connect-outer {
          padding: 6px;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #74d5ff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .content {
            width: 100%;
            padding: 12px 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            column-gap: 12px;

            .content-item {
              img {
                width: 32px;
                height: 32px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
